module.exports = __webpack_public_path__ + "img/hair_structure_splash.7ca77bc5.jpg";